import { Container, Section } from '@components';

const Settings = () => {
  return (
    <div className="bg-neutral-soft-gray min-h-screen">
      <Section>
        <Container>
          <div className="text-center py-16">
            <h1 className="text-h2 text-primary-navy mb-4">Settings</h1>
            <p className="text-body text-neutral-medium-gray">
              Coming in Phase 3 - User Settings
            </p>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Settings;
